import { Component, inject } from '@angular/core';
import {
  MaintenanceRequestModel,
  MaintenanceRequestService,
} from '../../core/services/maintenance-request-service';
import { BusyService } from '../../core/services/busy-service';
import { PagedParamsService } from '../../core/services/paged-params.service';
import { dateFormatter } from '../../util/utilFunc';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { AccountService } from '../../core/services/account-service';

@Component({
  selector: 'app-in-process-request',
  imports: [MatPaginator, RouterLink],
  templateUrl: './in-process-request.html',
  styleUrl: './in-process-request.scss',
})
export class InProcessRequest {
  private accountService = inject(AccountService);
  maintenanceRequestService = inject(MaintenanceRequestService);
  busyService = inject(BusyService);
  pagedParamsService = inject(PagedParamsService);
  dateFormatter = dateFormatter;
  private route = inject(ActivatedRoute);
  maintenanceRequests: MaintenanceRequestModel[] = [];
  showMyRequestsOnly = false;

  ngOnInit(): void {
    if (this.route.queryParams) {
      this.route.queryParams.subscribe((queryParams) => {
        const newParams = { ...this.pagedParamsService.pagedParams() };
        const pageNumber = queryParams['pageNumber'];
        const pageSize = queryParams['pageSize'];
        const orderBy = queryParams['orderBy'];
        const searchTerm = queryParams['searchTerm'];
        const statuses = queryParams['statuses'];
        const employeeId = queryParams['employeeId'];

        if (!pageNumber || !pageSize || !orderBy) {
          newParams.pageNumber = 1;
          newParams.pageSize = 20;
          newParams.orderBy = 'idDesc';
          this.pagedParamsService.setPagedParams(newParams);
        } else {
          newParams.pageNumber = +pageNumber;
          newParams.pageSize = +pageSize;
          newParams.orderBy = orderBy;
          newParams.searchTerm = searchTerm || '';

          var statusesFromFilter =
            this.maintenanceRequestService
              .maintenanceRequestFilterValues()

              ?.statuses.filter(
                (status) =>
                  status.toLowerCase() != 'completed' &&
                  status.toLowerCase() != 'cancelled',
              ) || [];
          newParams.statuses = statusesFromFilter.join(',') || '';
          newParams.employeeId = employeeId ? +employeeId : undefined;

          this.pagedParamsService.setPagedParams(newParams);
          this.maintenanceRequestService
            .getMaintenanceRequests(this.pagedParamsService.pagedParams())
            .subscribe({
              next: (response) => {
                this.maintenanceRequests = response.data;

                this.pagedParamsService.setPagedParams({
                  ...this.pagedParamsService.pagedParams(),
                  totalCount: response.totalCount,
                });
              },
            });
        }
      });
    }
  }

  onShowMyRequestsOnlyChange(Event: HTMLInputElement | Event | any): void {
    const newParams = { ...this.pagedParamsService.pagedParams() };
    newParams.pageNumber = 1; // Reset to first page when filter changes
    newParams.employeeId = this.accountService.user?.id || undefined;
    const isChecked = Event.target?.checked ?? false;
    if (!isChecked) {
      newParams.employeeId = undefined; // Clear employeeId filter if unchecked
    }
    console.log('onShowMyRequestsOnlyChange: newParams:', newParams);
    this.pagedParamsService.setPagedParams(newParams);
  }

  ngOnDestroy(): void {
    this.pagedParamsService.resetPagedParams();
  }

  onPageChange(event: any): void {
    this.pagedParamsService.setPagedParams({
      ...this.pagedParamsService.pagedParams(),
      pageNumber: event.pageIndex + 1,
      pageSize: event.pageSize,
    });
  }
}
